import NamedSlugTab from './NamedSlugTab';

export default function MaterialsTab(): JSX.Element {
  return (
    <NamedSlugTab
      endpoint="/admin/materials"
      singular="material"
      plural="materiais"
      placeholder="Nome (ex.: Algodão)"
    />
  );
}
